// eslint-disable-next-line import/prefer-default-export
export const selectorArrayItemEqFn = (a, b) => a === b
    || (a != null && b != null && (a?.length === b?.length && a.every((id, i) => b[i] === id)));
